import { ObjectDetail } from '@/commons/interface/object-detail'
import React from 'react'

interface IProps {
    detail: ObjectDetail
}
export default function ObjectDetailBasicPanel(props: IProps) {
    const detail = props.detail;
    return (
        <div className='basic-info-panel'>
            <div className='basic-info-title'>构成</div>
            <div className='basic-info-item'>
                <div className='sub-title'>
                    <div className='key'>子组件</div>
                    <div className='value'>材质</div>
                </div>
                {detail?.makeups?.map((makeup, idx) => (
                    <div className='sub-item' key={idx}>
                        <div className='key'>
                            {makeup.name}
                        </div>
                        <div className='value'>
                            {makeup.mat}
                        </div>
                    </div>
                ))}
            </div>

            <div className='basic-info-title'>空间尺寸</div>
            <div className='basic-info-item'>
                <div className='sub-title'>
                    <div className='key'>长*宽*高</div>
                    <div className='value'></div>
                </div>
                <div className='sub-item'>
                    <div className='key'>
                        {detail?.size}
                    </div>

                </div>
            </div>

            <div className='basic-info-title'>材质</div>
            <div className='basic-info-item'>
                <div className='sub-title'>
                    <div className='key'>材质</div>
                    <div className='value'>型号</div>
                </div>
                {detail?.materials?.map((mat, idx) => (
                    <div className='sub-item' key={idx}>
                        <div className='key'>
                            {mat.name}
                        </div>
                        <div className='value'>
                            {mat.type}
                        </div>
                    </div>
                ))}
            </div>

            <div className='basic-info-title'>周边链接</div>
            <div className='basic-info-item'>
                <div className='sub-title'>
                    <div className='key'>周边对象</div>
                    <div className='value'>材质</div>
                </div>
                <div className='sub-item'>
                    <div className='key'>
                        柱
                    </div>
                    <div className='value'>
                        钢
                    </div>
                </div>
            </div>
        </div>
    )
}
